export default {
    ELEMENT: 'm-element',
    PLACED_OBJECT: 'placed-object',
    PLACED_CHARACTER: 'placed-character',
    PLACED_TEXTBOX: 'placed-textbox',
    PLACED_TEXTBOX_FULLSCREEN: 'placed-textbox-fullscreen',
}